export const urls = {
    "API_HOST_URL" : "https://api.tunisiajobs.io/api/graphql"
}